import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "swiper-discounts__card" }
const _hoisted_2 = { class: "swiper-discounts__right" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "swiper-discounts__left" }
const _hoisted_5 = ["src"]

import { Autoplay } from 'swiper/modules';
import TitleDefault from "@/components/TitleDefault.vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MoreDiscounts',
  setup(__props) {

const slider = ref(null);

const onSwiper = (swiper: any) => {
    slider.value = swiper;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleDefault, {
      class: "swiper-discounts__title container",
      title: "Нужно больше скидок?",
      subtitle: "Добавьте к подписке всё, что вам необходимо из 60+ предложений наших партнёров"
    }),
    _createVNode(_unref(Swiper), {
      "space-between": 0,
      speed: 2000,
      loop: true,
      modules: [_unref(Autoplay)],
      autoplay: {
              delay: 0,
              disableOnInteraction: false
        },
      "slides-per-view": "auto",
      class: "swiper-discounts",
      onSwiper: onSwiper
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (index) => {
          return _createVNode(_unref(SwiperSlide), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: `img/pages/index/more-discounts/${index}.png`,
                    class: "swiper-discounts__img",
                    alt: "Логотип, нужно больше скидок"
                  }, null, 8, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: `img/pages/index/more-discounts/${index}${index}.png`,
                    class: "swiper-discounts__img",
                    alt: "Логотип, нужно больше скидок"
                  }, null, 8, _hoisted_5)
                ])
              ])
            ]),
            _: 2
          }, 1024)
        }), 64))
      ]),
      _: 1
    }, 8, ["modules"])
  ], 64))
}
}

})